(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('entgra-icons/dist/css/font-entgra.min.css')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'entgra-icons/dist/css/font-entgra.min.css'], factory) :
  (global = global || self, factory(global['react-fontawesome'] = {}, global.React));
}(this, (function (exports, React) { 'use strict';

  React = React && Object.prototype.hasOwnProperty.call(React, 'default') ? React['default'] : React;

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  //     type : string;
  //     style? : React.CSSProperties
  // }

  var EntgraIcon = function EntgraIcon(props) {
    return /*#__PURE__*/React.createElement("i", _extends({
      className: 'fw ' + props.type
    }, props));
  };

  exports.EntgraIcon = EntgraIcon;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
